import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ISibasiHTTPResponse } from 'src/app/common/model/sibasiHTTPResponse.model';
import { ILocation } from '../../models/location.model';
import { environment } from 'src/environments/environment';
import { IPagination } from 'src/app/common/model/util.model';

@Injectable({
  providedIn: 'root'
})
export class SibasiLocationService {
  constructor(private httpClient: HttpClient) {}

  getAllLocations(): Observable<ISibasiHTTPResponse<ILocation[]>> {
    return this.httpClient.get<ISibasiHTTPResponse<ILocation[]>>(
      `${environment.api_url}sLocation`
    );
  }
  getAllLocationSupervised(): Observable<ISibasiHTTPResponse<ILocation[]>> {
    return this.httpClient.get<ISibasiHTTPResponse<ILocation[]>>(
      `${environment.api_url}employees/slocations/reporting/me`
    );
  }

  getAllLocationsPagination(
    paginationParams: IPagination<ILocation[]>
  ): Observable<ISibasiHTTPResponse<IPagination<ILocation[]>>> {
    return this.httpClient.post<ISibasiHTTPResponse<IPagination<ILocation[]>>>(
      `${environment.api_url}sLocation/all/paginated`,
      paginationParams
    );
  }

  getLocationById(locationId: string): Observable<ISibasiHTTPResponse<ILocation>> {
    return this.httpClient.get<ISibasiHTTPResponse<ILocation>>(
      `${environment.api_url}sLocation/${locationId}`
    );
  }

  deleteLocation(locationId: string): Observable<ISibasiHTTPResponse<ILocation>> {
    return this.httpClient.delete<ISibasiHTTPResponse<ILocation>>(
      `${environment.api_url}sLocation/${locationId}`
    );
  }

  createLocation(location: ILocation): Observable<ISibasiHTTPResponse<ILocation>> {
    return this.httpClient.post<ISibasiHTTPResponse<ILocation>>(
      `${environment.api_url}sLocation`,
      location
    );
  }

  updateLocation(location: ILocation): Observable<ISibasiHTTPResponse<ILocation>> {
    return this.httpClient.post<ISibasiHTTPResponse<ILocation>>(
      `${environment.api_url}sLocation/${location._id}`,
      location
    );
  }
}
